import type {MemexColumnDataType} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class TextColumnModel extends BaseColumnModel {
  declare readonly id: number
  declare readonly dataType: typeof MemexColumnDataType.Text
  declare readonly userDefined: true
}
